import React from "react";
import ServicePageShell from "../ui/ServicePageShell";
import ServicePageCta from "../ui/ServicePageCta";
import { PrimaryLink } from "../ui/Buttons";
import SeoHead from "../seo/SeoHead";
import PageBreadcrumb from "../seo/PageBreadcrumb";
import Cool from "../../assets/coolant.jpg";

const CoolantFlush = () => {
  return (
    <>
      <SeoHead
        title="Coolant Flush in Temecula | Advanced Automotive Smog"
        description="Coolant flush in Temecula to remove old fluid and restore cooling performance, helping protect your engine from heat and corrosion."
        path="/services/coolant-flush"
      />
      <ServicePageShell>
        <PageBreadcrumb
          label="Coolant Flush"
          path="/services/coolant-flush"
          description="Coolant flush in Temecula to remove old fluid and restore cooling performance, helping protect your engine from heat and corrosion."
          serviceType="Coolant flush"
        />
        
        <div className="flex flex-col gap-10 md:flex-row md:items-center md:gap-14">

          {/* Image - prioritized for mobile */}
          <div className="w-full md:w-1/2 flex justify-center order-1 md:order-none">
            <div className="relative w-full max-w-xs sm:max-w-sm">
              <div className="absolute -inset-3 rounded-3xl bg-teal-600/10 blur-xl" />
              <img
                src={Cool}
                alt="Coolant flush service"
                className="relative w-full h-auto rounded-3xl border border-slate-200 object-cover shadow-xl"
              />
            </div>
          </div>

          {/* Text Content */}
          <div className="w-full md:w-1/2">
            <div className="mb-4 inline-flex items-center gap-2 rounded-full border border-slate-200 bg-slate-50 px-2.5 py-1 text-[11px] font-medium tracking-normal text-teal-700">
              <span className="h-1.5 w-1.5 rounded-full bg-teal-600" />
              Cooling System Service
            </div>

            <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold text-navy-900 mb-3">
              Coolant Flush
            </h1>

            <p className="text-sm sm:text-base text-slate-700 mb-6 leading-relaxed">
              Your engine relies on clean, effective coolant to stay at the right
              temperature. A coolant flush removes old, contaminated fluid and
              restores proper cooling performance—protecting your engine from heat
              and corrosion.
            </p>

            <h2 className="text-lg sm:text-xl font-semibold text-teal-600 mb-2">
              What Is a Coolant Flush?
            </h2>

            <p className="text-sm sm:text-base text-slate-700 mb-5 leading-relaxed">
              Over time, coolant breaks down and becomes less effective at absorbing heat.
              It may also accumulate rust particles or contaminants, which can clog
              your radiator or damage engine components.
              <br />
              <br />
              Our coolant flush service drains the old fluid, cleans the cooling
              system, and refills it with premium coolant to keep your engine
              running smoothly and efficiently.
            </p>

            <ul className="space-y-2.5 text-sm sm:text-base text-slate-700">
              <li className="flex items-start gap-2">
                <span className="mt-1 h-1.5 w-1.5 rounded-full bg-teal-600" />
                <span>Helps prevent overheating and engine failure</span>
              </li>

              <li className="flex items-start gap-2">
                <span className="mt-1 h-1.5 w-1.5 rounded-full bg-teal-600" />
                <span>Protects against corrosion and rust buildup</span>
              </li>

              <li className="flex items-start gap-2">
                <span className="mt-1 h-1.5 w-1.5 rounded-full bg-teal-600" />
                <span>Improves coolant efficiency and temperature control</span>
              </li>

              <li className="flex items-start gap-2">
                <span className="mt-1 h-1.5 w-1.5 rounded-full bg-teal-600" />
                <span>Works on all vehicles and engine types</span>
              </li>

              <li className="flex items-start gap-2">
                <span className="mt-1 h-1.5 w-1.5 rounded-full bg-teal-600" />
                <span>Professional fluid replacement and testing</span>
              </li>
            </ul>

            {/* Clean centered button */}
            <div className="mt-8 flex justify-center">
              <PrimaryLink
                to="/contact"
                className="px-10 text-base"
              >
                Book Appointment
              </PrimaryLink>
            </div>

          </div>

        </div>
            <ServicePageCta />
      </ServicePageShell>
    </>
  );
};

export default CoolantFlush;

